/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type NtpDateTimeSettingsDeviceFragment = { id: string, features: { networkTimeProtocol: { currentTime: string | null, enabled: boolean, lastSynchronizedTime: string | null, synchronized: boolean } | null, networkTimeProtocolServerConfiguration: { automaticConfiguration: Array<string>, manualConfiguration: Array<string>, mode: Types.DeviceNetworkTimeProtocolServerConfigurationMode } | null, authentication: { credentials: Array<{ accessLevel: string, credentialsState: Types.CredentialsState }> | null } | null }, description: { features: { networkTimeProtocol: { supported: boolean }, networkTimeProtocolServerConfiguration: { supported: boolean } } } };

export type NtpDateTimeSettingsDeviceChangeFragment = { id: string, features:
    | { authentication: { credentials: Array<{ accessLevel: string, credentialsState: Types.CredentialsState }> | null } | null }
    | { networkTimeProtocol: { currentTime: string | null, enabled: boolean, lastSynchronizedTime: string | null, synchronized: boolean } | null }
    | { networkTimeProtocolServerConfiguration: { automaticConfiguration: Array<string>, manualConfiguration: Array<string>, mode: Types.DeviceNetworkTimeProtocolServerConfigurationMode } | null }
    | Record<PropertyKey, never>
   };

export type NtpDateTimeCurrentTimeQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['ID']['input'];
}>;


export type NtpDateTimeCurrentTimeQueryOpResult = { node:
    | { id: string, features: { networkTimeProtocol: { currentTime: string | null } | null } }
    | Record<PropertyKey, never>
   };

export type NtpDateTimeSettingsDeviceQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['ID']['input'];
}>;


export type NtpDateTimeSettingsDeviceQueryOpResult = { node:
    | NtpDateTimeSettingsDeviceFragment
    | Record<PropertyKey, never>
   };

export type NtpDateTimeSettingsDeviceSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type NtpDateTimeSettingsDeviceSubscriptionOpResult = { nodeChanges:
    | NtpDateTimeSettingsDeviceFragment
    | NtpDateTimeSettingsDeviceChangeFragment
    | Record<PropertyKey, never>
   };

export type ToggleNetworkTimeProtocolMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ToggleNetworkTimeProtocolMutationOpResult = { updateNodes: Array<
    | { device: { features: { networkTimeProtocol: { enabled: boolean } | null } } | null, error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export type UpdateNtpServerConfigurationMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateNtpServerConfigurationMutationOpResult = { updateNodes: Array<
    | { device: { features: { networkTimeProtocolServerConfiguration: { automaticConfiguration: Array<string>, manualConfiguration: Array<string>, mode: Types.DeviceNetworkTimeProtocolServerConfigurationMode } | null } } | null, error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export const NtpDateTimeSettingsDeviceFragment = gql`
    fragment NtpDateTimeSettingsDeviceFragment on Device {
  id
  features {
    networkTimeProtocol {
      currentTime
      enabled
      lastSynchronizedTime
      synchronized
    }
    networkTimeProtocolServerConfiguration {
      automaticConfiguration
      manualConfiguration
      mode
    }
    authentication {
      credentials {
        accessLevel
        credentialsState
      }
    }
  }
  description {
    features {
      networkTimeProtocol {
        supported
      }
      networkTimeProtocolServerConfiguration {
        supported
      }
    }
  }
}
    `;
export const NtpDateTimeSettingsDeviceChangeFragment = gql`
    fragment NtpDateTimeSettingsDeviceChangeFragment on DeviceChange {
  id
  features {
    ... on DeviceAuthenticationChange {
      authentication {
        credentials {
          accessLevel
          credentialsState
        }
      }
    }
    ... on DeviceNetworkTimeProtocolChange {
      networkTimeProtocol {
        currentTime
        enabled
        lastSynchronizedTime
        synchronized
      }
    }
    ... on DeviceNetworkTimeProtocolServerConfigurationChange {
      networkTimeProtocolServerConfiguration {
        automaticConfiguration
        manualConfiguration
        mode
      }
    }
  }
}
    `;
export const NtpDateTimeCurrentTimeQueryDocument = gql`
    query NtpDateTimeCurrentTimeQuery($deviceId: ID!) {
  node(id: $deviceId) {
    ... on Device {
      id
      features {
        networkTimeProtocol {
          currentTime
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NtpDateTimeCurrentTimeQueryGQL extends Apollo.Query<NtpDateTimeCurrentTimeQueryOpResult, NtpDateTimeCurrentTimeQueryVariables> {
    override document = NtpDateTimeCurrentTimeQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NtpDateTimeSettingsDeviceQueryDocument = gql`
    query NtpDateTimeSettingsDeviceQuery($deviceId: ID!) {
  node(id: $deviceId) {
    ...NtpDateTimeSettingsDeviceFragment
  }
}
    ${NtpDateTimeSettingsDeviceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NtpDateTimeSettingsDeviceQueryGQL extends Apollo.Query<NtpDateTimeSettingsDeviceQueryOpResult, NtpDateTimeSettingsDeviceQueryVariables> {
    override document = NtpDateTimeSettingsDeviceQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NtpDateTimeSettingsDeviceSubscriptionDocument = gql`
    subscription NtpDateTimeSettingsDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...NtpDateTimeSettingsDeviceFragment
    ...NtpDateTimeSettingsDeviceChangeFragment
  }
}
    ${NtpDateTimeSettingsDeviceFragment}
${NtpDateTimeSettingsDeviceChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NtpDateTimeSettingsDeviceSubscriptionGQL extends Apollo.Subscription<NtpDateTimeSettingsDeviceSubscriptionOpResult, NtpDateTimeSettingsDeviceSubscriptionVariables> {
    override document = NtpDateTimeSettingsDeviceSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleNetworkTimeProtocolMutationDocument = gql`
    mutation ToggleNetworkTimeProtocolMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      device {
        features {
          networkTimeProtocol {
            enabled
          }
        }
      }
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleNetworkTimeProtocolMutationGQL extends Apollo.Mutation<ToggleNetworkTimeProtocolMutationOpResult, ToggleNetworkTimeProtocolMutationVariables> {
    override document = ToggleNetworkTimeProtocolMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNtpServerConfigurationMutationDocument = gql`
    mutation UpdateNtpServerConfigurationMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      device {
        features {
          networkTimeProtocolServerConfiguration {
            automaticConfiguration
            manualConfiguration
            mode
          }
        }
      }
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNtpServerConfigurationMutationGQL extends Apollo.Mutation<UpdateNtpServerConfigurationMutationOpResult, UpdateNtpServerConfigurationMutationVariables> {
    override document = UpdateNtpServerConfigurationMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }